import React, { Component } from "react";
import "./Tour.css";
import NewHeader from "../../Component/NewHeader/NewHeader";
import { PackageZoneData, getTourPackageList } from "../axios";
import Autosuggest from "react-autosuggest";
import moment from "moment";
import "react-image-gallery/styles/css/image-gallery.css";
import { Base64 } from "js-base64";
import DayPicker from "react-day-picker";
import "react-day-picker/lib/style.css";
import { Helmet } from "react-helmet";
import TawkToWidget from "../../Component/TawkToWidget";
import PackageShowcase from "../../Component/AdminPackageDetails/PackageShowcase";

class PackageDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchInput: "",
      error: null,
      nav: false,
      value: "",
      suggestionsPackage: [],
      showResultsPackage: false,
      defaultZonevalPackage: "Seychelles",
      tour_data: "",
      selectPackageDay: moment(new Date()).format("dddd, MMM D, YYYY"),
      selectPackageDayNew: new Date(),
      checkinShowPackageMain: false,
      CartIndexNumber: null,
      packageName: "",
    };
  }

  componentDidMount() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const name = urlParams.get("name");
    const package_name = urlParams.get("package_name");
    const dateSelected = urlParams.get("dateselected");
    const indexNumber = urlParams.get("IndexNumber");

    this.setState({
      defaultZonevalPackage: name,
      packageName: package_name,
      CartIndexNumber: indexNumber,
      selectPackageDay: moment(new Date(dateSelected)).format(
        "dddd, MMM D, YYYY"
      ),
      selectPackageDayNew: moment(dateSelected).format("Y-MM-DD"),
    });

    PackageZoneData().then(
      (data) => {
        this.setState({
          itemsZonePackage: data,
        });
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );

    window.addEventListener("scroll", this.handleScroll);
  }

  SearchListing = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const checkin = urlParams.get("checkin");
    const checkout = urlParams.get("checkout");
    const package_name = urlParams.get("package_name");
    const guestCombination = urlParams.get("guestCombination");
    const itineraryPlan = urlParams.get("itineraryPlan");
    const _packageID = urlParams.get("package_id");
    const package_id = Base64.atob(_packageID);

    const url =
      "/packageDetails?package_id=" +
      Base64.btoa(package_id) +
      "&name=" +
      encodeURIComponent(this.state.defaultZonevalPackage) +
      "&checkin=" +
      encodeURIComponent(checkin) +
      "&checkout=" +
      encodeURIComponent(checkout) +
      "&guestCombination=" +
      guestCombination +
      "&itineraryPlan=" +
      encodeURIComponent(itineraryPlan) +
      "&moreLocation=" +
      encodeURIComponent(this.state.defaultZonevalPackage) +
      "&dateselected=" +
      encodeURIComponent(this.state.selectPackageDayNew) +
      "&package_name=" +
      encodeURIComponent(package_name);

    window.location.replace(url);
  };
  componentWillUnmount() {
    // document.removeEventListener('click', this.globalClickListener)
    window.removeEventListener("click", this.globalClickListener);
    window.removeEventListener("scroll", this.handleScroll);
  }
  globalClickListener = (nativeEvent) => {
    this.setState(
      {
        showResultsPackage: false,
        checkinShowPackageMain: false,
      },
      () => {
        // document.removeEventListener('click', this.globalClickListener)
        window.removeEventListener("click", this.globalClickListener);
      }
    );
  };
  checkinandcheckoutPackageMain = (syntheticEvent) => {
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({
        checkinShowPackageMain: !prevState.checkinShowPackageMain,
      }),
      () => {
        if (this.state.checkinShowPackageMain) {
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
  };

  handleBodyClick = (event) => {
    event.stopPropagation();
  };
  getSuggestionsPackage = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : this.state.itemsZonePackage.filter(
        (lang) => lang.Name.toLowerCase().slice(0, inputLength) === inputValue
      );
  };

  onSuggestionsFetchRequestedPackage = ({ value }) => {
    this.setState({
      suggestionsPackage: this.getSuggestionsPackage(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequestedPackage = () => {
    this.setState({
      suggestionsPackage: [],
    });
  };

  onSuggestionSelectedPackage = () => {
    this.setState({
      showResultsPackage: false,
    });
  };

  getSuggestionValuePackage = (suggestion) => suggestion.Name;

  // Use your imagination to render suggestions.
  renderSuggestionPackage = (suggestion, { query, isHighlighted }) => (
    <div className="font14 darkText  noChild  clickable">
      <div className="hsFlexspaceBetween hsFlex hrtlCenter ">
        {suggestion.LocationImage != "nolocation" ? (
          <div className="locationImage">
            <img
              src={suggestion.LocationImage}
              className="locationImageContent"
            />
          </div>
        ) : (
          <div className="tourImage">
            {" "}
            <img src={suggestion.Image} className="locationImageContent2" />
          </div>
        )}
        <div className="flexOne">
          <p className="locusLabel appendBottom5 fontSizeChange">
            {suggestion.Name}
          </p>
        </div>
      </div>
    </div>
  );

  renderSuggestionsContainerPackage = ({ containerProps, children }) => {
    return (
      <div {...containerProps}>
        <div class="react-autosuggest__section-title">
          <label class="hsw_sectionTitle font12 latoBlack greyText">
            SUGGESTIONS{" "}
          </label>
        </div>
        <div> {children}</div>
      </div>
    );
  };
  handlePackageDayClickMain = (day, { selected, disabled }) => {
    if (disabled) {
      // If the day is disabled, do nothing
      return;
    }
    this.setState({ selectPackageDayNew: selected ? undefined : day });
    this.setState({ selectPackageDay: moment(day).format("ddd, D MMM yy") });
    this.setState({ checkinShowPackageMain: false });
  };

  showZonelistdivPackage = (syntheticEvent) => {
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ showResultsPackage: !prevState.showResultsPackage }),
      () => {
        if (this.state.showResultsPackage) {
          // document.addEventListener('click', this.globalClickListener)
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
  };

  handleScroll = () => {
    if (window.pageYOffset > 10) {
      if (!this.state.nav) {
        this.setState({ nav: true });
      }
    } else {
      if (this.state.nav) {
        this.setState({ nav: false });
      }
    }
  };
  onChangePackage = (event, { newValue }) => {
    this.setState({
      value: newValue,
      defaultZonevalPackage: newValue,
    });
  };

  render() {
    const { value, suggestionsPackage } = this.state;
    const inputPropsPackage = {
      placeholder: "Enter location or package name",
      type: "search",
      value,
      onChange: this.onChangePackage,
    };

    return (
      <div className="Detail-container">
        <Helmet>
          <title>Best Packages Deals in Seychelles- Holidays Seychelles</title>
          <meta
            name="description"
            content="Get best packages deals in Seychelles. One of the best honeymoon destination in the world."
          />
          <meta
            name="keywords"
            content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"
          />
        </Helmet>
        <h1 style={{ color: "#fff" }}>
          Best Packages Deals in Seychelles- Holidays Seychelles
        </h1>
        <NewHeader page={"inner"} tabName={3} />
        <div
          className={`${this.state.nav == true ? "_Hlisting_header_new" : "_Hlisting_header"
            }`}
        >
          <div className="container hsw">
            <div className="hsw_inner">
              <div
                className="hsw_inputBoxActivity  "
              // onClick={this.showZonelistdivPackage}
              >
                <label
                  for="city"
                  className="lbl_input latoBold font12 blueText"
                >
                  Location
                </label>
                <p
                  className="hsw_inputField font16 whiteText"
                  style={{ marginBottom: "3px" }}
                >
                  {this.state.packageName}
                  {/* {this.state.defaultZonevalPackage.length >= 35
                    ? `${this.state.defaultZonevalPackage.substring(0, 35)}...`
                    : this.state.defaultZonevalPackage} */}
                </p>
                {/* <div className="focused_div">
                  {this.state.showResultsPackage ? (
                    <div
                      className="autocomplete-wrapper"
                      onClick={this.handleBodyClick}
                    >
                      <Autosuggest
                        suggestions={suggestionsPackage}
                        onSuggestionsFetchRequested={
                          this.onSuggestionsFetchRequestedPackage
                        }
                        onSuggestionSelected={this.onSuggestionSelectedPackage}
                        onSuggestionsClearRequested={
                          this.onSuggestionsClearRequestedPackage
                        }
                        getSuggestionValue={this.getSuggestionValuePackage}
                        renderSuggestionsContainer={
                          this.renderSuggestionsContainerPackage
                        }
                        renderSuggestion={this.renderSuggestionPackage}
                        inputProps={inputPropsPackage}
                      />
                    </div>
                  ) : null}
                </div> */}
              </div>
              <div
                className="hsw_inputBoxActivity"
                onClick={this.checkinandcheckoutPackageMain}
              >
                <span className="checkinandcheckout">
                  <label
                    for="checkin"
                    className="lbl_input latoBold font12 blueText capText"
                  >
                    When are you traveling?
                  </label>
                </span>
                <p className="hsw_inputField font16 whiteText">
                  {this.state.selectPackageDay}
                </p>
                <div onClick={this.handleBodyClick}>
                  {this.state.checkinShowPackageMain && (
                    <DayPicker
                      className="activityDate"
                      onDayClick={this.handlePackageDayClickMain}
                      selectedDays={this.state.selectPackageDayNew}
                      disabledDays={{ before: new Date() }}
                      month={new Date()} // Ensure the current month is displayed initially
                      fromMonth={new Date()} // Disable navigation to months before today
                    />
                  )}
                </div>
              </div>

              <span
                className="primaryBtn hsw_searchButton"
                onClick={this.SearchListing}
              >
                Search
              </span>
            </div>
          </div>
        </div>
        <div
          className="container"
          style={{ marginTop: 40, maxWidth: "1210px" }}
        >
          <PackageShowcase />
        </div>
        <TawkToWidget />
      </div>
    );
  }
}
export default PackageDetails;
